import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../Shared/Sidebar';
import Icon from '../Shared/Icons';
import { PROGRAMS } from '../../config/programs';
import { fetchMembers, fetchReports } from '../../utils/programData';
import {
  summarise, weeklyTrend, CHESS_METRICS, LIFESKILLS_METRICS,
} from '../../utils/programMetrics';
import { analyseAcrossPrograms } from '../../utils/programAI';
import { S, T } from './ui';

// ── ULINGANISHO WA PROGRAMU ZOTE ────────────────────────────────────────
// Hapa ndipo swali "mbinu ya chess + lifeskills imetusaidiaje?" linajibiwa.
// Inawezekana kwa sababu bloku hizo mbili zinaulizwa MASWALI YALEYALE
// kwenye kila programu — leo tatu, kesho tano.

export default function CrossProgram() {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [ai, setAi] = useState('');
  const [aiBusy, setAiBusy] = useState(false);
  const [err, setErr] = useState('');

  useEffect(() => { load(); }, []);

  async function load() {
    setLoading(true);
    try {
      const out = [];
      for (const p of PROGRAMS) {
        const [members, reports] = await Promise.all([
          fetchMembers(p.id),
          fetchReports({ programId: p.id, kind: 'individual' }),
        ]);
        out.push({
          id: p.id,
          name: p.name,
          short: p.short,
          color: p.color,
          icon: p.icon,
          members: members.length,
          summary: summarise(reports),
          trend: weeklyTrend(reports),
        });
      }
      setRows(out);
    } catch (e) { console.error(e); setErr('Imeshindikana kupakia data.'); }
    setLoading(false);
  }

  async function runAI() {
    setAiBusy(true); setErr('');
    try { setAi(await analyseAcrossPrograms(rows)); }
    catch (e) { console.error(e); setErr('AI haipatikani kwa sasa.'); }
    setAiBusy(false);
  }

  const withData = rows.filter(r => r.summary.count > 0);
  const totalReports = rows.reduce((a, r) => a + r.summary.count, 0);

  return (
    <div style={S.layout}>
      <Sidebar />
      <div style={S.main}>

        <div onClick={() => navigate('/programs')} style={{ fontSize: '12px', color: T.muted, cursor: 'pointer', marginBottom: '8px' }}>
          ← Programu
        </div>
        <h1 style={S.h1}>Chess & Lifeskills — Programu Zote</h1>
        <p style={{ ...S.sub, marginTop: '6px', marginBottom: '18px' }}>
          Maswali ya chess na lifeskills ni <strong>yaleyale</strong> kwenye kila programu.
          Ndio maana tunaweza kulinganisha moja kwa moja — na kuona kama mbinu hii
          inatusaidia, wapi zaidi, na wapi pungufu. Wastani wa chess unahesabu
          tu wale wanaojifunza chess (kwa wazazi ni hiari), hivyo hakuna
          anayeshusha takwimu bila sababu.
        </p>

        {err && <div style={S.err}>{err}</div>}

        {loading ? (
          <div style={{ ...S.card, ...S.empty }}>Inapakia…</div>
        ) : totalReports === 0 ? (
          <div style={{ ...S.card, ...S.empty }}>
            Bado hakuna ripoti binafsi. Ulinganisho utaanza kuonekana
            baada ya wiki ya kwanza ya ripoti.
          </div>
        ) : (
          <>
            {/* Muhtasari wa kila programu */}
            {rows.map(r => (
              <div key={r.id} style={{ ...S.card, borderLeft: `4px solid ${r.color}` }}>
                <div
                  onClick={() => navigate(`/programs/${r.id}`)}
                  style={{ display: 'flex', alignItems: 'center', gap: '11px', cursor: 'pointer' }}
                >
                  <div style={{
                    width: '36px', height: '36px', borderRadius: '11px', flexShrink: 0,
                    background: `${r.color}15`, display: 'flex', alignItems: 'center', justifyContent: 'center',
                  }}>
                    <Icon name={r.icon} size={16} color={r.color} />
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: '14.5px', fontWeight: 700, color: T.ink }}>{r.name}</div>
                    <div style={{ fontSize: '11.5px', color: T.muted, marginTop: '2px' }}>
                      Wanachama {r.members} · ripoti {r.summary.count}
                    </div>
                  </div>
                  <span style={{ color: T.muted }}>›</span>
                </div>

                {r.summary.count === 0 ? (
                  <div style={{ fontSize: '12px', color: T.muted, marginTop: '13px' }}>
                    Bado hakuna ripoti kwenye programu hii.
                  </div>
                ) : (
                  <>
                    <div style={{ display: 'flex', gap: '10px', marginTop: '15px', flexWrap: 'wrap' }}>
                      <Big value={r.summary.chessAvg ?? '–'} suffix="/5" label="Chess" color={r.color} />
                      <Big value={r.summary.lifeAvg ?? '–'} suffix="/5" label="Lifeskills" color="#00695C" />
                      <Big value={r.summary.chessAttendance ?? '–'} suffix="%" label="Mahudhurio" color="#4527A0" />
                      <Big value={r.summary.winRate ?? '–'} suffix="%" label="Ushindi" color="#E07A2E" />
                    </div>

                    <div style={{ marginTop: '17px' }}>
                      <Group title="Chess" metrics={CHESS_METRICS} data={r.summary.chess} color={r.color} />
                      <Group title="Lifeskills" metrics={LIFESKILLS_METRICS} data={r.summary.life} color="#00695C" />
                    </div>
                  </>
                )}
              </div>
            ))}

            {/* Ulinganisho wa moja kwa moja */}
            {withData.length > 1 && (
              <div style={S.card}>
                <h2 style={S.h2}>Ulinganisho wa Moja kwa Moja</h2>
                <div style={{ overflowX: 'auto' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12.5px', minWidth: '380px' }}>
                    <thead>
                      <tr>
                        <th style={th}>Kipimo</th>
                        {withData.map(r => (
                          <th key={r.id} style={{ ...th, color: r.color, textAlign: 'center' }}>{r.short}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      <Tr label="Wastani wa chess" rows={withData} pick={s => s.chessAvg} suffix="/5" />
                      <Tr label="Wastani wa lifeskills" rows={withData} pick={s => s.lifeAvg} suffix="/5" />
                      <Tr label="Mahudhurio ya chess" rows={withData} pick={s => s.chessAttendance} suffix="%" />
                      <Tr label="Mahudhurio ya lifeskills" rows={withData} pick={s => s.lifeAttendance} suffix="%" />
                      <Tr label="Michezo iliyochezwa" rows={withData} pick={s => s.gamesPlayed} />
                      <Tr label="Kiwango cha ushindi" rows={withData} pick={s => s.winRate} suffix="%" />
                      <Tr label="Ripoti zilizoandikwa" rows={withData} pick={s => s.count} />
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            {/* Mwenendo wa wiki */}
            {withData.some(r => r.trend.length > 1) && (
              <div style={S.card}>
                <h2 style={S.h2}>Chess na Lifeskills Vinapanda Pamoja?</h2>
                <div style={{ ...S.sub, marginBottom: '15px' }}>
                  Kama mistari miwili inapanda pamoja, ni ishara kwamba mbinu ya
                  kuchanganya chess na lifeskills inafanya kazi.
                </div>
                {withData.filter(r => r.trend.length > 1).map(r => (
                  <div key={r.id} style={{ marginBottom: '20px' }}>
                    <div style={{ fontSize: '12.5px', fontWeight: 700, color: r.color, marginBottom: '9px' }}>
                      {r.short}
                    </div>
                    <div style={{ display: 'flex', gap: '6px', alignItems: 'flex-end', height: '60px' }}>
                      {r.trend.slice(-10).map((t, i) => (
                        <div key={i} style={{ flex: 1, display: 'flex', gap: '2px', alignItems: 'flex-end', height: '100%' }}>
                          <div style={{
                            flex: 1, height: `${((t.chess || 0) / 5) * 100}%`,
                            background: r.color, borderRadius: '3px 3px 0 0', minHeight: t.chess ? '3px' : '0',
                          }} title={`Chess ${t.chess}`} />
                          <div style={{
                            flex: 1, height: `${((t.life || 0) / 5) * 100}%`,
                            background: '#00695C', borderRadius: '3px 3px 0 0', minHeight: t.life ? '3px' : '0',
                          }} title={`Lifeskills ${t.life}`} />
                        </div>
                      ))}
                    </div>
                    <div style={{ display: 'flex', gap: '14px', marginTop: '8px', fontSize: '10.5px', color: T.muted }}>
                      <span><span style={{ display: 'inline-block', width: '9px', height: '9px', background: r.color, borderRadius: '2px', marginRight: '4px' }} />Chess</span>
                      <span><span style={{ display: 'inline-block', width: '9px', height: '9px', background: '#00695C', borderRadius: '2px', marginRight: '4px' }} />Lifeskills</span>
                      <span style={{ marginLeft: 'auto' }}>wiki {r.trend.slice(-10).length} za mwisho</span>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {/* AI */}
            <div style={S.card}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '10px', marginBottom: '11px' }}>
                <div>
                  <h2 style={{ ...S.h2, marginBottom: '2px' }}>AI: Mbinu Imetusaidiaje?</h2>
                  <div style={{ fontSize: '11.5px', color: T.muted }}>
                    Ulinganisho wa programu {withData.length} · ripoti {totalReports}
                  </div>
                </div>
                <button style={{ ...S.btn, background: T.orange, padding: '10px 16px', opacity: aiBusy ? 0.6 : 1 }}
                  disabled={aiBusy} onClick={runAI}>
                  {aiBusy ? 'Inafikiri…' : 'Chambua'}
                </button>
              </div>
              {ai ? (
                <div style={{
                  fontSize: '13.5px', color: T.ink, lineHeight: 1.85, whiteSpace: 'pre-wrap',
                  background: '#FAF8F3', padding: '16px', borderRadius: '12px',
                }}>{ai}</div>
              ) : (
                <div style={{ fontSize: '12.5px', color: T.muted, lineHeight: 1.6 }}>
                  AI italinganisha programu zote na kukuambia kama kuna ushahidi
                  kwamba chess na lifeskills vinasaidiana — na programu ipi ina la kufundisha nyingine.
                </div>
              )}
            </div>
          </>
        )}

      </div>
    </div>
  );
}

const th = {
  textAlign: 'left', padding: '9px 8px', fontSize: '11.5px',
  color: '#6B7280', fontWeight: 800, borderBottom: '1px solid #E8E4DA',
};

function Tr({ label, rows, pick, suffix = '' }) {
  const vals = rows.map(r => pick(r.summary));
  const nums = vals.filter(v => typeof v === 'number');
  const best = nums.length ? Math.max(...nums) : null;
  return (
    <tr>
      <td style={{ padding: '10px 8px', borderBottom: '1px solid #F3F1EB', color: '#374151' }}>{label}</td>
      {rows.map((r, i) => (
        <td key={r.id} style={{
          padding: '10px 8px', borderBottom: '1px solid #F3F1EB', textAlign: 'center',
          fontWeight: vals[i] === best && best !== null ? 800 : 500,
          color: vals[i] === best && best !== null ? '#059669' : '#1A1A1A',
        }}>
          {vals[i] === null || vals[i] === undefined ? '–' : `${vals[i]}${suffix}`}
        </td>
      ))}
    </tr>
  );
}

function Big({ value, suffix, label, color }) {
  return (
    <div style={{ background: `${color}0F`, borderRadius: '11px', padding: '10px 14px', minWidth: '82px' }}>
      <div style={{ fontSize: '19px', fontWeight: 800, color, lineHeight: 1 }}>
        {value}<span style={{ fontSize: '11px', fontWeight: 600 }}>{value === '–' ? '' : suffix}</span>
      </div>
      <div style={{ fontSize: '10.5px', color: T.muted, marginTop: '4px' }}>{label}</div>
    </div>
  );
}

function Group({ title, metrics, data, color }) {
  const any = metrics.some(m => data[m.key]);
  if (!any) return null;
  return (
    <div style={{ marginBottom: '14px' }}>
      <div style={{ fontSize: '11.5px', fontWeight: 800, color, marginBottom: '8px' }}>{title}</div>
      {metrics.map(m => {
        const v = data[m.key];
        return (
          <div key={m.key} style={{ display: 'flex', alignItems: 'center', gap: '9px', marginBottom: '6px' }}>
            <div style={{ fontSize: '11.5px', color: T.muted, width: '110px', flexShrink: 0 }}>{m.label}</div>
            <div style={{ flex: 1, height: '7px', background: '#F0EEE7', borderRadius: '99px', overflow: 'hidden' }}>
              <div style={{ width: `${((v || 0) / 5) * 100}%`, height: '100%', background: color }} />
            </div>
            <div style={{ fontSize: '11.5px', fontWeight: 700, color: T.ink, width: '26px', textAlign: 'right' }}>
              {v ?? '–'}
            </div>
          </div>
        );
      })}
    </div>
  );
}
